import { defineMessages } from 'react-intl';

export const confirmationCardMessages = defineMessages({
  trackingHeader: {
    id: 'w/ahY/',
    description: 'Tracking card header in booking confirmation',
    defaultMessage: 'Tracking & Status',
  },
  statusLabel: {
    id: 'EnepGJ',
    description: 'Status label in tracking card',
    defaultMessage: 'Status',
  },
  bolNumberLabel: {
    id: 'oAwq2T',
    description: 'BOL number label in tracking card',
    defaultMessage: 'BOL Number',
  },
  copyBolNumber: {
    id: 'XnQ4Mj',
    description: 'Tooltip for copy BOL number button in tracking card',
    defaultMessage: 'Copy BOL number',
  },
  proNumberLabel: {
    id: '4RVrJM',
    description: 'PRO number label in tracking card',
    defaultMessage: 'PRO Number',
  },
  confirmationNumberLabel: {
    id: 'k/YZuE',
    description: 'Confirmation number label in tracking card',
    defaultMessage: 'Confirmation Number',
  },
  pickupConfirmationLabel: {
    id: 'yF+eHg',
    description: 'Pickup confirmation label in tracking card',
    defaultMessage: 'Pickup Confirmation',
  },
  shipmentDetailsHeader: {
    id: 'XFp7Re',
    description: 'Shipment details card header in booking confirmation',
    defaultMessage: 'Shipment Details',
  },
  originLabel: {
    id: 'VErPwH',
    description: 'Origin address label in shipment details card',
    defaultMessage: 'Origin',
  },
  destinationLabel: {
    id: 'tFiEEe',
    description: 'Destination address label in shipment details card',
    defaultMessage: 'Destination',
  },
  shipDateLabel: {
    id: 'xcFc7z',
    description: 'Ship date label in shipment details card',
    defaultMessage: 'Ship Date',
  },
  estimatedDeliveryLabel: {
    id: 'U+nZvU',
    description: 'Estimated delivery label in shipment details card',
    defaultMessage: 'Estimated Delivery',
  },
  transitDaysLabel: {
    id: 'G0pkLn',
    description: 'Transit days label in shipment details card',
    defaultMessage: 'Transit Days',
  },
  transitDaysValue: {
    id: 'KW/3tz',
    description: 'Transit days value with pluralization in shipment details card',
    defaultMessage: '{days, plural, one {# day} other {# days}}',
  },
  handlingUnitsHeader: {
    id: 'jZurjj',
    description: 'Handling units card header in booking confirmation',
    defaultMessage: 'Handling Units',
  },
  handlingUnitDescription: {
    id: 'sbcbB8',
    description: 'Handling unit type and quantity in handling units card',
    defaultMessage: '{type} × {quantity}',
  },
  commodityDescription: {
    id: 'Vf8re0',
    description: 'Commodity freight class and description in handling units card',
    defaultMessage: 'Class {freightClass} · {description}',
  },
  noHandlingUnits: {
    id: 'e2UpkW',
    description: 'Message when no handling units are present',
    defaultMessage: 'No handling units',
  },
  documentsHeader: {
    id: 'XBy/Fo',
    description: 'Documents card header in booking confirmation',
    defaultMessage: 'Documents',
  },
  billOfLading: {
    id: 'UYs/sD',
    description: 'Bill of Lading document type in documents card',
    defaultMessage: 'Bill of Lading',
  },
  packingList: {
    id: '2brlgd',
    description: 'Packing List document type in documents card',
    defaultMessage: 'Packing List',
  },
  palletLabels: {
    id: '1vU2Dl',
    description: 'Pallet Labels document type in documents card',
    defaultMessage: 'Pallet Labels',
  },
  rateQuote: {
    id: 'Np9WRG',
    description: 'Rate Quote document type in documents card',
    defaultMessage: 'Rate Quote',
  },
  printDocument: {
    id: 'FLUng8',
    description: 'Print document button label in documents card',
    defaultMessage: 'Print',
  },
  costHeader: {
    id: 'vQIkn9',
    description: 'Cost card header in booking confirmation',
    defaultMessage: 'Cost',
  },
  carrierLabel: {
    id: 'dZ2V/P',
    description: 'Carrier label in cost card',
    defaultMessage: 'Carrier',
  },
  serviceLabel: {
    id: 'iKqrqK',
    description: 'Service label in cost card',
    defaultMessage: 'Service',
  },
  totalWeightLabel: {
    id: 'RgCbZJ',
    description: 'Total weight label in cost card',
    defaultMessage: 'Total Weight',
  },
  totalChargesLabel: {
    id: 'TRN6rb',
    description: 'Total charges label in cost card',
    defaultMessage: 'Total Charges',
  },
});
